import { render } from "./MailSubView.vue?vue&type=template&id=823cc2f4&scoped=true&ts=true"
import script from "./MailSubView.vue?vue&type=script&lang=ts"
export * from "./MailSubView.vue?vue&type=script&lang=ts"

import "./MailSubView.vue?vue&type=style&index=0&id=823cc2f4&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-823cc2f4"]])

export default __exports__